

import { api } from './api';
import { getTenant } from '../helpers';
import { callMainTenantAPIsOnly } from './helpers';


const fetchUserPathwaysData = (tenantKey: string, username: string) => {
  return new Promise<any[]>((resolve, reject) => {
    const requestData = {
      username: username,
      platform_key: tenantKey,
    };

    api.ibledxpathway.getUserPathways(
      requestData,
      (data) => {
        resolve(data || []);
      },
      (error) => {
        console.error('getUserPathwaysAPI: ', error);
        reject(error);
      }
    );
  });
};

export function getUserPathwaysAPI(username: string, callback) {
  const tenant = getTenant();
  const shouldCallMainTenantOnly = callMainTenantAPIsOnly();

  const fetchMainUserPathways = () => fetchUserPathwaysData('main', username);

  if (tenant === 'main' || shouldCallMainTenantOnly) {
    fetchMainUserPathways()
      .then(data => {
        callback(data);
      })
      .catch((error) => {
        console.error(error);
        callback([]);
      });
  } else {
    Promise.all([
      fetchUserPathwaysData(tenant, username).catch((error) => {
        console.error(error);
        return [];
      }),
      fetchMainUserPathways().catch((error) => {
        console.error(error);
        return [];
      }),
    ])
      .then((results) => {
        const validResults = results.filter(result => result !== null).flat();
        const uniqueData = filterUniquePathways(validResults);
        callback(uniqueData);
      })
      .catch((error) => {
        console.error(error);
        callback([]);
      });
  }
}

const filterUniquePathways = (data) => {
  const seen = new Set();
  return data.filter(item => {
    const duplicate = seen.has(item.id);
    seen.add(item.id);
    return !duplicate;
  });
};


